module.exports = __webpack_public_path__ + "static/media/master-chens-fortune.566fa99d.gif";